import i18n from "../../i18n";
import axios from "axios";

const actions = {
  multiuserClientsSwitch(context, value) {
    return axios
      .post("multiuser/clients/switch", value)
      .then(function (r) {
        context.commit("CREATE_SNACKBAR", i18n.t("snackbars.multiuserChanged"));
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  multiuserCodeRedeem(context, value) {
    return axios
      .post("multiuser/invite/" + value.code + "/redeem", value)
      .then(function (r) {
        context.commit("CREATE_SNACKBAR", i18n.t("snackbars.multiuserAdded"));
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  multiuserRevoke(context, value) {
    return axios
      .post("multiuser/revoke", value)
      .then(function (r) {
        context.commit("CREATE_SNACKBAR", i18n.t("snackbars.multiuserRemoved"));
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  multiuserInvite(context, value) {
    return axios
      .post("multiuser/invite", value)
      .then(function (r) {
        context.commit("CREATE_SNACKBAR", i18n.t("snackbars.multiuserInvited"));
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  getMultiuserClients(context) {
    return axios
      .get("multiuser/clients")
      .then(function (r) {
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  switchMultiuserClients(context, item) {
    return axios
      .post("multiuser/clients/switch", item)
      .then(function (r) {
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },
};

export default actions;
